import React from 'react';
import { shiftSummaryDashboardPending } from "./FatigueAssessmentPageSelector";
import { FatigueAssessmentView } from './FatigueAssessmentView';
import FatigueAssessmentDashboard from "./FatigueAssessmentDashboard";

const FatigueAssessmentDashboardPending = () => {
    return (
        <FatigueAssessmentDashboard
            page={shiftSummaryDashboardPending}
            pageView={FatigueAssessmentView.Pending}
        />
    );
}

export default FatigueAssessmentDashboardPending;
